export const common = {
  // ... předchozí položky ...

  // Cart
  'cart.title': 'Shopping Cart',
  'cart.empty': 'Your cart is empty',
  'cart.item': 'Item',
  'cart.quantity': 'Quantity',
  'cart.price': 'Price',
  'cart.subtotal': 'Subtotal',
  'cart.memberPrice': 'Member price',
  'cart.savings': 'You save',
  'cart.checkout': 'Proceed to checkout',
  'cart.continueShopping': 'Continue shopping',
  'cart.remove': 'Remove',
  'cart.hangers': 'Hangers',
  'cart.bags': 'Bags',
  'cart.ownHangers': 'Own hangers/bag',
  'cart.free': 'FREE',
  'cart.addHangers': 'Add hangers',
  'cart.addBags': 'Add bags',
  'cart.quickCart': 'Quick Cart',
  'cart.items': 'items',
  'cart.addService': 'Add service:',
  'cart.membershipActive': 'Membership',
  'cart.monthlyUsage': 'Monthly usage',
  'cart.used': 'Used',
  'cart.of': 'of',
  'cart.thisMonth': 'this month',
  'cart.unlimited': 'unlimited',
  'cart.shippingFree': 'Shipping FREE',
  'cart.services': 'Services:',
  'cart.memberSavings': 'Member savings:',
  'cart.discount': 'Discount:',
  'cart.shipping': 'Shipping:',
  'cart.freeShipping': 'FREE',
  'cart.membership': '(Membership)',
  'cart.almostFreeShipping': 'Only {amount} CZK until free shipping!',
  'cart.total': 'Total:',
  'cart.deliveryTime': 'Delivery:',
  'cart.standardDelivery': 'Standard delivery: 72 hours',
  // zachována podrobná verze
  'cart.expressDelivery': 'Express delivery: within 48 hours',
  'cart.pickupDelivery': 'Pickup and delivery: Monday - Friday',
  'cart.specialRequest': 'Do you have a special request or service not in the price list?',
  'cart.specialRequestPlaceholder': 'E.g: I need to iron a wedding dress, I have special fabric...',
  'cart.maxChars': 'Maximum 500 characters',
  'cart.completeOrder': 'Complete order',
  'cart.memberPricesApplied': 'Member prices applied',
  'cart.noRegistration': 'No registration • Quick checkout',
  'cart.perPiece': '/ piece',
  'cart.vipOnly': 'VIP Only',
  'cart.freeShippingVip': 'FREE (VIP)',
  'cart.shippingCost': '399 CZK',
  'cart.expressDeliveryOption': 'Express delivery within 48h',
  'cart.expressDeliveryCost': '+500 CZK',
  'cart.weekendPickup': 'Weekend pickup',
  'cart.weekendPickupCost': '+299 CZK',
  'cart.weekendPickupDesc': 'Available in Prague and Stará Boleslav',
  'cart.byArrangement': 'By arrangement',
  'cart.standardDeliveryTime': 'Standard delivery time: 72 hours',
  // odstraněna duplicitní položka 'cart.expressDelivery'
  'cart.expressDeliveryTime': 'Express delivery: within 48 hours',
  'cart.expressDeliveryPrice': '+500 CZK',
  'cart.fastDelivery': 'Fast delivery',
  'cart.fastDeliveryTime': 'Fast delivery: 24 hours',
  'cart.fastDeliveryPrice': '+300 CZK',

  // Partner (previously Affiliate)
  'partner.title': 'Partner Program',
  'partner.subtitle': 'Earn with us as a partner',
  'partner.howItWorks': 'How it works',
  'partner.benefits': 'Benefits',
  'partner.earnings': 'Earnings calculator',
  'partner.joinNow': 'Join now',
  'partner.successStories': 'Success stories',
  'partner.hero.title': 'Become our partner',
  'partner.hero.subtitle': 'Earn commission for every customer',
  'partner.info.title': 'Program information',
  'partner.info.subtitle': 'Everything you need to know',
  'partner.video.title': 'Video tutorials',
  'partner.video.subtitle': 'Learn how to maximize earnings',
};
export default common;